const kformElementBindTemplateDirective = /* @ngInject */ (
	/** @type {import('angular').ICompileService} */ $compile,
) => ({
	restrict: 'A',
	/**
	 * @param {any} scope
	 * @param {any} element
	 * @param {any} attributes
	 */
	link:     (scope, element, attributes) => {
		scope.$watch(
			() => scope.$eval(attributes.kformElementBindTemplate),
			(/** @type {string} */ value) => {
				element.html(value && value.toString());
				let compileScope = scope;
				if (attributes.bindHtmlScope) {
					compileScope = scope.$eval(attributes.bindHtmlScope).$new();
				}
				compileScope.index = Number.parseInt(attributes.index ?? '0');
				$compile(element.contents())(compileScope);
			},
		);
	},
});

export default kformElementBindTemplateDirective;
